import styles from './css/PasswordRecoveryWrapper.css';

import React from 'react';
import propTypes from 'prop-types';

import ContactSupportInfo from '../../components/passwordRecovery/ContactSupportInfo';

const PasswordRecoveryWrapper =
  ({children, supportEmail, supportPhoneNumber, isCountryKnown}) =>
    (<div className={styles.passwordRecoveryContainer}>
      <div className={styles.card}>
        {children}
      </div>
      <div className={styles.divider} />
      <ContactSupportInfo
        isCountryKnown={isCountryKnown}
        supportEmail={supportEmail}
        supportPhoneNumber={supportPhoneNumber}
      />
    </div>
    );

PasswordRecoveryWrapper.propTypes = {
  children: propTypes.object.isRequired,
  isCountryKnown: propTypes.bool.isRequired,
  supportEmail: propTypes.string.isRequired,
  supportPhoneNumber: propTypes.string.isRequired
};

export default PasswordRecoveryWrapper;
